import AboutCab from "../components/common/About";

export default function About() {
    return (
        <section className="py-5 mt-5">
            <div className="container">
                <div className="row">
                    <AboutCab />
                </div>
            </div>
        </section>
    );
}
